import get from "lodash/get";
import { defaultObject } from "redux-store/selectors";

function isAuthenticated(auth) {
  const token = get(auth, "token", "");

  return Boolean(token);
}

function isSessionExpired(auth) {
  return get(auth, "sessionExpired", null);
}

function authSelector(state) {
  return get(state, "global.auth", defaultObject);
}

function getAuthUser(state) {
  return get(state, "global.auth.user", null);
}

function getVistarAccountIds(state) {
  return get(state, "global.auth.user.account.vistar_account_ids", null);
}

export {
  authSelector,
  getAuthUser,
  getVistarAccountIds,
  isAuthenticated,
  isSessionExpired,
};
